/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateEmbedUrlMethodRequest
 */
export interface UpdateEmbedUrlMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateEmbedUrlMethodRequest
     */
    'embedUrlMethod': UpdateEmbedUrlMethodRequestEmbedUrlMethodEnum;
}

export const UpdateEmbedUrlMethodRequestEmbedUrlMethodEnum = {
    none: 'NONE',
    back: 'BACK',
    front: 'FRONT'
} as const;

export type UpdateEmbedUrlMethodRequestEmbedUrlMethodEnum = typeof UpdateEmbedUrlMethodRequestEmbedUrlMethodEnum[keyof typeof UpdateEmbedUrlMethodRequestEmbedUrlMethodEnum];


